import React from 'react'
import styled from '@emotion/native'
import Lobby from '~/components/partials/Lobby'
import Progress from '~/components/views/Progress'

export default Progress
// export default function Home() {
//     return <Lobby footer={true}></Lobby>
// }
